import React, {useEffect, useState} from "react";
import Card from "@mui/material/Card";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import moment from "moment/moment";
import {useTranslation} from "react-i18next";
import TicketListItem from "../support/ticket/card/TicketListItem";
import {getTicketAssignee, Logout, onErrorAlert} from "../../actions";
import {useDispatch} from "react-redux";
import {noop} from "lodash";
import {useNavigate} from "react-router-dom";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";

const OrderTicketInfo = ({tickets = [] , loading, setDialogOpen = noop}) => {
    const [isOpen,setIsOpen] = useState(true)
    const {t} = useTranslation()
    const [assigneeList, setAssigneeList] = useState([]);
    const dispatch = useDispatch()
    const nav = useNavigate()
    const convertTime = (date)=>{
        let serverTime = moment.tz(date, "America/Toronto")
        return  moment(serverTime).local().format('YYYY-MM-DD HH:mm')
    }

    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    useEffect(() => {
        const apiPost = async () => {
            await dispatch(getTicketAssignee((data)=>{

                setAssigneeList(data)
            },onError))
        }
        checkPermission(PERMISSION_DICT.SupportTicketAssignee) && apiPost().then()
    }, []);



    return(<React.Fragment>
        <Card data-testid="wholesale-preview-ticket-records" sx={{minWidth: 250}}>
            <MDBox
                mx={1}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="light"
                borderRadius="lg"
                coloredShadow="light"
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-between'}

            >
                <MDTypography variant="h6">
                    {t('Ticket Records')}
                </MDTypography>
                <IconButton size={'small'} disabled={loading} onClick={()=>setIsOpen(!isOpen)}>
                    {(isOpen && !loading)?<Icon>expand_less</Icon>:<Icon>expand_more</Icon>}
                </IconButton>
            </MDBox>
            <Collapse in={isOpen && !loading} timeout={500}>
                <MDBox
                    pt={1}     // ✅ 上边距（和 header 分开）
                    pb={2}
                    px={2}     // ✅ 左右留白（关键）
                >
                    <MDBox
                        display="grid"
                        gap={1.5}
                        sx={{
                            gridTemplateColumns: {
                                xs: "minmax(0, 1fr)",
                                md: "repeat(auto-fill, 282px)",
                            },
                            "& > div": {
                                minWidth: 0,
                                width: "100%",
                                maxWidth: { xs: "100%", md: 282 },
                            },
                            "& > div > div": {
                                width: "100%",
                                maxWidth: "100%",
                                boxSizing: "border-box",
                                overflow: "hidden",
                            },
                        }}
                    >
                        {tickets?.map((ticket, index) => (
                            <div
                                data-testid="wholesale-preview-ticket-record"
                                style={{ width: "100%" }} onClick={()=>{
                                setDialogOpen(false)
                                nav(`/app/support/ticket_management?ticketId=${ticket?.ticketId}`);
                            }}>
                                <TicketListItem
                                    key={ticket.ticketId || index}
                                    ticket={ticket}
                                    assigneeList={assigneeList}
                                />
                            </div>

                        ))}
                    </MDBox>
                </MDBox>
            </Collapse>

        </Card>
    </React.Fragment>)
}

export default OrderTicketInfo
